// extracted by mini-css-extract-plugin
export default {"app":"App_app__-Qzen"};